import { generateUniqueId } from '../../../../common/utils/utils';
import CardWithIcon from '../../../../widgets/cardWithIcon/CardWithIcon';
import css from './Counter.module.scss';

const Counter = ({ data }) => {
    if (!data) return null;
    return (
        <div className={css.wrapper}>
            {data.map((item) => (
                <CardWithIcon
                    key={generateUniqueId()}
                    icon={item.icon}
                    name={item.title}
                    component={<div></div>}
                    formatted_value={item.value}
                    deleted_value={item.subValue}
                />
            ))}
        </div>
    );
};

export default Counter;
